module.exports = __webpack_public_path__ + "static/img/icon-png.b478e8f7.jpg";